import { ChevronUp16 } from 'ui/icons';
import {
  QueryBuilderHeaderWrapper,
  StyledFilterIcon,
  StyledGhostButton,
} from './QueryBuilderSection.styles';
import { useTranslation } from '../../hooks';

export const testIds = {
  hideQueryBuilderButton: 'hide-query-builder-button',
  queryBuilderHeader: 'query-builder-header',
};

export const QueryBuilderHeader = ({ hideQueryBuilder }: { hideQueryBuilder: () => void }) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderHeaderWrapper data-test={testIds.queryBuilderHeader}>
      <StyledGhostButton
        data-header-collapsed={false}
        data-test={testIds.hideQueryBuilderButton}
        onClick={hideQueryBuilder}
      >
        <StyledFilterIcon height={20} width={20} />
        <span>{t('button.minimizeFilters')}</span>
        <ChevronUp16 />
      </StyledGhostButton>
    </QueryBuilderHeaderWrapper>
  );
};
